import React, { useState, useEffect, useRef } from 'react';
import { auth, db } from './firebase';
import { doc, onSnapshot, updateDoc, increment, collection, query, orderBy, limit } from 'firebase/firestore';

const Watch = ({ onBack }) => {
    const [points, setPoints] = useState(0);
    const [claimTimer, setClaimTimer] = useState(0); 
    const [isWatching, setIsWatching] = useState(false);
    const [videoId, setVideoId] = useState('');
    const [videoList, setVideoList] = useState([]);
    const [memberType, setMemberType] = useState('FREE');
    const [isPlayerReady, setIsPlayerReady] = useState(false); 
    const playerRef = useRef(null);

    // Adsterra Popunder Link အမှန် (pl28579910)
    const POPUNDER_URL = "https://pl28579910.effectivegatecpm.com/98/61/5d/98615d32322f98309b73f04f04972ab1.js";

    useEffect(() => {
        if (!window.YT) {
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            document.body.appendChild(tag);
        }
        const q = query(collection(db, "videos"), orderBy("createdAt", "desc"), limit(20));
        const unsubVideos = onSnapshot(q, (snap) => {
            const vids = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            setVideoList(vids);
            if (vids.length > 0 && !videoId) setVideoId(vids[0].videoId);
        });
        if (auth.currentUser) {
            const unsubUser = onSnapshot(doc(db, "users", auth.currentUser.uid), (snap) => {
                if (snap.exists()) {
                    setPoints(snap.data().points || 0);
                    setMemberType(snap.data().memberType ? snap.data().memberType.toUpperCase() : 'FREE');
                }
            });
            return () => { unsubVideos(); unsubUser(); };
        }
    }, [videoId]);

    useEffect(() => {
        let timeoutId;
        const initPlayer = () => {
            if (window.YT && window.YT.Player) {
                if (playerRef.current && playerRef.current.loadVideoById) {
                    if (videoId) playerRef.current.loadVideoById(videoId);
                } else {
                    playerRef.current = new window.YT.Player('player-div', {
                        height: '100%', width: '100%', videoId: videoId,
                        playerVars: { 'autoplay': 1, 'rel': 0, 'modestbranding': 1, 'playsinline': 1, 'mute': 1 },
                        events: { 
                            'onReady': () => setIsPlayerReady(true),
                            'onStateChange': (e) => setIsWatching(e.data === 1) 
                        }
                    });
                }
            } else { timeoutId = setTimeout(initPlayer, 500); }
        };
        if (videoId) initPlayer();
        return () => clearTimeout(timeoutId);
    }, [videoId]);

    // Timer Logic: ၅ မိနစ်ပြည့်ရင် Claim ခွင့်ပေး၊ ၁၀ မိနစ် (၆၀၀ စက္ကန့်) မှာ ရပ်။
    useEffect(() => {
        let intv;
        if (isWatching) {
            intv = setInterval(() => {
                setClaimTimer(prev => (prev >= 600 ? prev : prev + 1));
            }, 1000);
        }
        return () => clearInterval(intv);
    }, [isWatching]);

    const claim = async () => {
        if (!auth.currentUser) return alert("Please Login First");
        if (claimTimer < 300) return alert(`${Math.ceil((300 - claimTimer) / 60)} မိနစ် ထပ်ကြည့်ပေးပါ။`);

        // Popunder Ads Trigger
        const script = document.createElement('script');
        script.src = POPUNDER_URL;
        document.body.appendChild(script);

        const earned = Math.floor(claimTimer / 60) * (memberType === 'PREMIUM' ? 3 : 1);
        try {
            await updateDoc(doc(db, "users", auth.currentUser.uid), { points: increment(earned) });
            alert(`ဂုဏ်ယူပါတယ်! ${earned} Points ရပါပြီ!`);
            setClaimTimer(0);
        } catch (e) { alert("Error: Point သိမ်းမရပါ။"); }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <button onClick={onBack} style={styles.iconBackBtn}>Back</button>
                <span style={styles.headerTitle}>Watch & Earn</span>
                <div style={{width: 40}}></div>
            </div>

            <div style={styles.videoWrapper}>
                <div style={styles.videoResponsiveContainer}>
                    <div id="player-div" style={{position: 'absolute', top:0, left:0, width:'100%', height:'100%'}}></div>
                    {!isPlayerReady && <div style={styles.loadingOverlay}><p>Loading...</p></div>}
                </div>
            </div>
            
            <div style={styles.infoCard}>
                <p style={styles.timerText}>
                    {Math.floor(claimTimer/60)}:{(claimTimer%60).toString().padStart(2, '0')}
                </p>

                <button 
                    onClick={claim} 
                    disabled={claimTimer < 300}
                    style={{
                        ...styles.claimBtn, 
                        opacity: claimTimer < 300 ? 0.6 : 1,
                        background: claimTimer >= 600 ? '#ff5252' : (claimTimer < 300 ? '#444' : '#00c853'),
                        cursor: claimTimer < 300 ? 'not-allowed' : 'pointer'
                    }}
                >
                    {claimTimer < 300 
                        ? `${Math.ceil((300 - claimTimer) / 60)} mins left` 
                        : claimTimer >= 600 
                            ? 'Limit Reached! Claim Now' 
                            : 'Claim Points & Rewards'}
                </button>
            </div>

            <div style={{padding: '15px', paddingBottom: '80px'}}>
                <h4>Video Library</h4>
                {videoList.map((vid) => (
                    <div 
                        key={vid.id} 
                        style={{
                            ...styles.videoCard, 
                            border: videoId === vid.videoId ? '2px solid gold' : '1px solid #ddd',
                            background: videoId === vid.videoId ? '#fffbe6' : '#fff'
                        }} 
                        onClick={() => { setVideoId(vid.videoId); setClaimTimer(0); }}
                    >
                        <img src={`https://img.youtube.com/vi/${vid.videoId}/mqdefault.jpg`} width="100" style={{borderRadius: '5px'}} alt="thumb" />
                        <div style={{marginLeft: '10px', flex: 1}}>
                            <p style={{margin: '0 0 5px 0', fontWeight: 'bold', fontSize: '14px'}}>{vid.title || 'Untitled Video'}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const styles = {
    container: { background: '#f8f9fa', minHeight: '100vh', fontFamily: 'sans-serif' },
    header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '15px', background: '#fff', borderBottom: '1px solid #eee' },
    iconBackBtn: { padding: '8px 16px', borderRadius: '8px', border: 'none', background: '#eee', cursor: 'pointer', fontWeight: 'bold' },
    headerTitle: { fontWeight: 'bold', fontSize: '18px' },
    videoWrapper: { background: '#000', width: '100%' },
    videoResponsiveContainer: { position: 'relative', paddingTop: '56.25%', width: '100%', overflow: 'hidden' },
    loadingOverlay: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', background: '#000', zIndex: 1 },
    infoCard: { padding: '20px', margin: '15px', borderRadius: '20px', background: '#fff', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' },
    timerText: { fontSize: '40px', textAlign: 'center', margin: '10px 0', fontFamily: 'monospace', fontWeight: 'bold' },
    claimBtn: { width: '100%', padding: '15px', color: '#fff', border: 'none', borderRadius: '12px', fontWeight: 'bold', fontSize: '16px', transition: '0.3s' },
    videoCard: { display: 'flex', padding: '10px', borderRadius: '12px', marginBottom: '10px', cursor: 'pointer', alignItems: 'center' }
};

export default Watch;